module.exports = __webpack_public_path__ + "img/horse-back-ride.36edd160.jpg";